import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InfoStep } from '../backend-process/backend-process-presentation/backend-process-presentation.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { NgTemplateOutlet } from '@angular/common';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-next-steps',
  templateUrl: './next-steps.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BasicCardComponent, NgTemplateOutlet, TranslatePipe, SafeHtmlPipe],
})
export class NextStepsComponent {
  readonly asCard = input<boolean>(false);
  readonly processTitle = input<string>('');
  readonly infoSteps = input<InfoStep[]>([]);
  readonly stepsTitle = input<string>('summary.whatNext');

  readonly formattedSteps = computed(() =>
    this.infoSteps()?.map(step => {
      return {
        ...step,
        label: Array.isArray(step?.label) ? step?.label : [step?.label],
      };
    }),
  );
}
